import get from 'lodash/get';
import moment from 'moment/moment';
import { mapGender } from '../../helpers/gender';
import {
  CITIZENSHIP_VALUES,
  MAIN_DATA_FIELD_NAMES
} from '../../constants/citizenship';
import { DATE_FORMAT } from '../../helpers/date';

/* eslint-disable camelcase */
const mainDataSerializer = (response, acsProfile) => {
  const {
    person,
    registration_data,
    snils,
    children,
    passport_rf
  } = response.data;
  const {
    first_name: firstName,
    last_name: lastName,
    middle_name: middleName
  } = acsProfile;

  const hasPassportFields = Object.values(passport_rf).some(
    element => !!element
  );

  const gender = mapGender(person.gender);
  const phone = get(registration_data, 'phone_mp', '') || '';
  const email = get(registration_data, 'email', '') || '';
  const birthdate = person.birthdate
    ? moment(person.birthdate, DATE_FORMAT).format(DATE_FORMAT)
    : null;

  return {
    snils,
    data: {
      firstName,
      lastName,
      middleName,
      gender,
      phone,
      email,
      birthdate,
      citizenship: hasPassportFields ? CITIZENSHIP_VALUES[0] : '',
      snils: snils.snils_number || '',
      children,
      [MAIN_DATA_FIELD_NAMES.birthRegistrationPlace]: ''
    },
    editableFields: {
      firstName: !firstName,
      lastName: !lastName,
      // Если в ЕЛК нет отчества, то так и нужно,
      // Даем редактировать только в случае, когда у пользователя пустое ФИО
      middleName: !firstName && !lastName && !middleName,
      gender: !gender,
      phone: !phone,
      email: !email,
      birthdate: !birthdate,
      citizenship: !person.citizenship,
      snils: !snils.snils_number,
      [MAIN_DATA_FIELD_NAMES.birthRegistrationPlace]: true
    }
  };
};
/* eslint-enable camelcase */

export default mainDataSerializer;
